import { c as _c } from "react/compiler-runtime";
import React from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { ApiWaveDecisionWinner } from "@/generated/models/ApiWaveDecisionWinner";
import { useWave } from "@/hooks/useWave";
import { DefaultWaveWinnersDrop } from "./DefaultWaveWinnerDrop";
import { MemesWaveWinnersDrop } from "./MemesWaveWinnerDrop";
interface WaveWinnersDropProps {
  readonly winner: ApiWaveDecisionWinner;
  readonly wave: ApiWave;
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly isApprovalWave?: boolean | undefined;
}
export const WaveWinnersDrop: React.FC<WaveWinnersDropProps> = t0 => {
  const $ = _c(8);
  const {
    winner,
    wave,
    onDropClick,
    isApprovalWave: t1
  } = t0;
  const isApprovalWave = t1 === undefined ? false : t1;
  const {
    isMemesWave
  } = useWave(wave);
  if (isMemesWave) {
    let t2;
    if ($[0] !== onDropClick || $[1] !== wave || $[2] !== winner) {
      t2 = <MemesWaveWinnersDrop winner={winner} wave={wave} onDropClick={onDropClick} />;
      $[0] = onDropClick;
      $[1] = wave;
      $[2] = winner;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== isApprovalWave || $[5] !== onDropClick || $[6] !== winner) {
    t2 = <DefaultWaveWinnersDrop winner={winner} onDropClick={onDropClick} isApprovalWave={isApprovalWave} />;
    $[4] = isApprovalWave;
    $[5] = onDropClick;
    $[6] = winner;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
};